import React, { useEffect } from 'react'
import "./Latest_Articles.css";
import Common_Title_3 from "../../common/common_components/Common_Title_3/Common_Title_3";
import Latest_Card from "../../common/common_components/latest_card/Latest_Card";
import { useDispatch, useSelector } from 'react-redux';
import { AllChants, allInsightsArticle } from '../../../features/admin/common/Slice';
import { IDS } from '../../../utils/IDS';
import { encodeId } from '../../../utils/common';

const Latest_Articles = () => {



  const dispatch = useDispatch();
  const articles = useSelector((state) => state.common.all_insight_article);


  useEffect(() => {
    dispatch(allInsightsArticle());
  }, [dispatch])
  return (
    <section className='Latest_Articles'>
      <div className="container">
        <Common_Title_3 titleText="Latest Articles" seelink={'/all-articles'} />

        <div className="row">
          {articles?.slice(0, 4)?.map(
            ((article, index) => (
              <div className="col-xl-3 col-md-4 col-sm-6 mb-4" key={index}>
                <Latest_Card
                  mediaContent={
                    <img src={IDS.IMG_URL + article?.Insight_Article?.image} className='media_content' />
                  }
                  name={article?.name}
                  description={article?.subname}
                  link={`/article-description/${encodeId(article?.id)}`}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  )
}

export default Latest_Articles
